import { useEffect, useMemo } from 'react';
import { useStore } from 'store/store';
import { GetBrokersResponse, useUtxExchangeSubAccountGetBrokers } from '../../../../../packages/utx-client/src/react';
import { ErrorCode } from '../enum';

export interface UseSelectBrokersProp {
  getBrokers: {
    brokers: GetBrokersResponse;
    isLoading: boolean;
    refetch: () => void;
  };
}

export const useSelectBrokers = (): UseSelectBrokersProp => {
  const store = useStore();

  // Get brokers
  const queryGetBrokers = useUtxExchangeSubAccountGetBrokers({
    query: {
      enabled: false
    },
    axios: {
      headers: {
        Authorization: `Bearer ${store.authToken}`
      }
    }
  });

  const brokers: GetBrokersResponse = useMemo(() => {
    if (queryGetBrokers.data && queryGetBrokers.data.data) {
      const data: GetBrokersResponse = queryGetBrokers.data.data;
      return data;
    }
    return [];
  }, [queryGetBrokers.data?.data]);

  const isLoadingGetBrokers = useMemo(() => {
    return queryGetBrokers.isLoading;
  }, [queryGetBrokers.isLoading]);

  useEffect(() => {
    if (queryGetBrokers.error) {
      var statusCode: number | undefined = queryGetBrokers.error.response?.status;
      if (statusCode !== ErrorCode.EXPIRED_TOKEN_ERROR) {
        refetchApi();
      }
    }
  }, [queryGetBrokers.error]);

  const refetchApi = () => {
    queryGetBrokers.refetch();
  };

  return {
    getBrokers: {
      brokers,
      isLoading: isLoadingGetBrokers,
      refetch: refetchApi
    }
  };
};
